import {
    SET_BOOKING_DETAILS,
    DELETE_BOOKING_DETAILS
} from './types';


export function SetCurrentBooking(value){
    return dispatch => dispatch({type:SET_BOOKING_DETAILS, payload:value});
}


export function DeleteCurrentBooking(){
    return dispatch => dispatch({type:DELETE_BOOKING_DETAILS, payload:{}});
}